<template>
  <div id="app">
    <el-container class="service-page-qiangzhi-buxudong">
<!--      <meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no">-->
      <el-header class="hidden-sm-and-down header_pc" height="218px">
        <el-row class="head_dingbu">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="head_width">
              <span class="head_text">仪海仪家</span>
              <img class="head_dingwei" src="../../../assets/home/dingwei.png"/>
              <span
                  class="head_text head_text_cao_left">HI!{{
                  $store.state.information != '' ? $store.state.information.name : ''
                }}</span>
              <img class="head_youxiang" src="../../../assets/home/xiaoxi.png"/>
              <a class="xuanzhong wenzi" href="">
              <span class="head_text head_text_xiaoxi_left">
                消息</span></a>
              <a class="xuanzhong wenzi youfudong" href="">
              <span class="hidden-md-and-down head_text head_text_wangzhan_left">
                网站导航</span></a>
              <a class="xuanzhong wenzi youfudong" href="">
              <span class="hidden-md-and-down head_text head_text_kefu_left">
                客服中心</span></a>
              <a class="xuanzhong wenzi youfudong" href="">
              <span class="head_text head_text_wode_left">
                我的收藏</span></a>
              <a class="xuanzhong wenzi youfudong" href="">
              <span class="head_text head_text_shangjia_left">
                商家工作台</span></a>
              <a class="xuanzhong wenzi youfudong" href="">
              <span class="head_text head_text_shouye_left">
                首页</span></a>
              <a class="xuanzhong wenzi youfudong" href="/user.html#/">
                <span class="head_text head_text_denglu_left">
                 {{ $store.state.information != '' ? '' : '登录/注册' }}</span></a>


            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="head_width">
              <div class="header_logo_top">
                <el-row>
                  <el-col :xs="8" :sm="8" :md="5" :lg="8" :xl="8">
                    <a class="xuanzhong wenzi " href="">
                      <img class="header_logo" src="../../../assets/home/logo.png"/>
                    </a>
                  </el-col>
                  <el-col :xs="16" :sm="16" :md="19" :lg="16" :xl="16">
                    <div class="header_sousuo">
                      <img class="header_sousuo_logo" src="../../../assets/home/sousuo_logo.png">
                      <div class="header_sousuo_tuijian "
                           :class="is_open.sousuo==1?'header_sousuo_tuijian_xuanzhong':''" @click="sousuo_xuanxiang(1)">
                        找商品
                      </div>
                      <div class="header_sousuo_tuijian header_sousuo_tuijian_2"
                           :class="is_open.sousuo==2?'header_sousuo_tuijian_xuanzhong':''" @click="sousuo_xuanxiang(2)">
                        找服务
                      </div>
                      <div class="header_sousuo_tuijian header_sousuo_tuijian_3"
                           :class="is_open.sousuo==3?'header_sousuo_tuijian_xuanzhong':''" @click="sousuo_xuanxiang(3)">
                        仪小星讲堂
                      </div>
                      <input style="background:none; outline:none; border:none; height: 100%;width: 450px"/>

                    </div>
                    <button class="header_sousuo_button"><a href="#/search" style="color: #FFFFFF">搜索</a></button>
                  </el-col>
                </el-row>
              </div>
              <el-row>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <div class="header_gongye_lianjie">
                    <div class="header_gongye_kuang">
                      <div class="header_gongye_kuang_text " @click="is_open.lanmu=1">工业产品</div>
                      <div class="header_gongye_kuang_text" @click="is_open.lanmu=2">专业服务</div>
                      <div class="header_gongye_kuang_zhuangtai2" style="margin-left: 37px"
                           v-if="is_open.lanmu===1"></div>
                      <div class="header_gongye_kuang_zhuangtai2" v-if="is_open.lanmu===2"></div>
                    </div>
                    <a class="xuanzhong wenzi" href="">
                      <div class="header_gongye_lianjie_qiota header_gongye_lianjie_qiota_xuanzhong">首页</div>
                    </a>
                    <a class="xuanzhong wenzi" href="#/shop">
                      <div class="header_gongye_lianjie_qiota">聚仪商城</div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="header_gongye_lianjie_qiota">服务直达</div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="header_gongye_lianjie_qiota">检验检测</div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="header_gongye_lianjie_qiota">仪兵仪将</div>
                    </a>
                    <a class="xuanzhong wenzi" href="">
                      <div class="hidden-md-and-down header_gongye_lianjie_qiota">二手商品</div>
                    </a>
                    <a class="xuanzhong wenzi" href="#/college">
                      <div class="hidden-md-and-down header_gongye_lianjie_qiota">仪小星讲堂</div>
                    </a>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-header class="hidden-sm-and-up header_phone" height="38px">
        <span class="header_phone_name">仪海仪家</span>
        <img class="head_phone_dingwei" src="../../../assets/home/dingwei.png"/>
        <span
            class="head_phone_huanyi">HI!{{
            $store.state.information != '' ? $store.state.information.name : '您好'
          }}</span>
        <img class="head_phone_xiaoxi_img" src="../../../assets/home/xiaoxi.png"/>
        <span class="head_phone_xiaoxi">消息</span>
        <span class="head_phone_zhuce">{{ $store.state.information != '' ? '' : '[免费注册]' }}</span>
        <span class="head_phone_denglu">{{ $store.state.information != '' ? '' : '[登录]' }}</span>
      </el-header>
      <el-main class="service-main">
        <div class="service-head-background">
          <el-row>
            <el-col class="service-head-title" :xs="24" :sm="2" :md="2">综合</el-col>
            <el-col class="service-head-input" :xs="24" :sm="2" :md="3">
              <el-input
                  placeholder="请输入关键字"
                  v-model="input"
                  clearable>
              </el-input>
              <a @click="input_sj(input)" class="search-logo">
                <img  src="../../../assets/home/sousuo_logo.png" alt="">
              </a>
            </el-col>
          </el-row>
        </div>


        <el-row :gutter="15" v-for="(item,index) in casezhi" v-bind:key="index">
          <a v-bind:href="$route.path!=='/college/case?shop_id'?'#/college/category/'+ item.id:'#/college/case?shop_id'+ item.id">
            <div class="service-main-background">
              <el-col :xs="24" :sm="4" :md="4">
                <el-image class="service-main-picture" :src="url+'/storage/'+item.pic" fit="cover" >
                  <div slot="error" class="image-slot">
                    <img src="../../../assets/wenzhangfengmian.png" alt="" >
                    <!--                        <i class="el-icon-picture-outline"></i>-->
                  </div>
                </el-image>
              </el-col>
              <el-col :xs="24" :sm="20" :md="20">
                <div class="service-main-title">
                  <div class="service-main-title1">{{item.title}}</div>
                </div>
                <el-row>
                  <el-col :xs="24" :sm="24" :md="24">
                    <div class="service-main-title2">发布者：{{item.username}}</div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24">
                    <div class="service-main-title2">浏览次数：{{item.view_count}}</div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24">
                    <div class="service-main-title2">发布时间：{{item.created_at}}</div>
                  </el-col>
                </el-row>
              </el-col>
            </div>
          </a>
        </el-row>
        <div data-v-6af373ef="" class="el-pagination is-background" style="margin-top: 40px">
          <span class="el-pagination__total">共 {{ zongshu }} 条</span>
          <el-pagination
              style="float: left;margin-bottom: 150px"
              layout="prev, pager, next"
              @current-change="yedianji"
              :total="yemashu*10">
          </el-pagination>
        </div>
      </el-main>
      <el-footer class="hidden-sm-and-down" height="480px">
        <el-row class=" footer">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class=" footer_width">
              <div class="xdsk_top">
                <el-row :gutter="160" class="hidden-md-and-down">
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <div>
                      <img class="footer_img_xinshou" src="../../../assets/home/xinshou.png"/>
                      <span class="footer_text3 footer_xinshou_left">新手指南</span>
                      <div style="margin-top: 20px;" class="footer_text1 footer_kongjian_left">平台规则；服务条款；</div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <div>
                      <img class="footer_img_duiwai" src="../../../assets/home/duiwai.png"/>
                      <span class="footer_text3 footer_dsk_left">担保交易</span>
                      <div style="margin-top: 20px" class="footer_text1 footer_jiaoyi_left">交易方式；支付方式</div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <img class="footer_img_shiming" src="../../../assets/home/shiming.png"/>

                    <span class="footer_text3 footer_dsk_left">实名认证</span>
                    <div style="margin-top: 20px" class="footer_text1 footer_jiaoyi_left">企业认证；个人认证</div>

                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <img class="footer_img_kefu" src="../../../assets/home/kefu.png"/>
                    <span class="footer_text3 footer_dsk_left">客服中心</span>
                    <div style="margin-top: 20px" class="footer_text1 footer_tousu_left">投诉建议；交易维权；</div>
                  </el-col>
                </el-row>
                <el-row class="hidden-lg-and-up">
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <div>
                      <img class="footer_img_xinshou" src="../../../assets/home/xinshou.png"/>
                      <span class="footer_text3 footer_xinshou_left">新手指南</span>
                      <div style="margin-top: 20px;" class="footer_text1 footer_kongjian_left">空间规则；服务条款；</div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <div>
                      <img class="footer_img_duiwai" src="../../../assets/home/duiwai.png"/>
                      <span class="footer_text3 footer_dsk_left">担保交易</span>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <img class="footer_img_shiming" src="../../../assets/home/shiming.png"/>

                    <span class="footer_text3 footer_dsk_left">实名认证</span>
                    <div style="margin-top: 20px" class="footer_text1 footer_jiaoyi_left">交易方式；支付方式</div>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                    <img class="footer_img_kefu" src="../../../assets/home/kefu.png"/>
                    <span class="footer_text3 footer_dsk_left">客服中心</span>
                    <div style="margin-top: 20px" class="footer_text1 footer_tousu_left">投诉建议；交易维权；</div>
                    <div class="footer_text1 footer_changjian_left">常见问题</div>
                  </el-col>
                </el-row>
              </div>

            </div>
          </el-col>
        </el-row>

        <el-row class="footer footer_bottom">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="footer_width">
              <div class="glzy_top">
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">联系我们</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">隐私政策</span>
                </a>
<!--                <a class="xuanzhong wenzi" href="">-->
<!--                  <span class="footer_text2 footer_lxwm_left">平台规则</span>-->
<!--                </a>-->
<!--                <a class="xuanzhong wenzi" href="">-->
<!--                  <span class="footer_text2 footer_lxwm_left">服务条款</span>-->
<!--                </a>-->
              </div>
              <div class="glzy_bottom">
                <span class="footer_text2 ">
                  Copyright@2020 海粟智链（青岛）科技有限公司
                  版权所有鲁ICP备 19060515号-1</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-footer>
      <el-footer class="hidden-sm-and-up" height="300px">
        <el-row class="footer footer_bottom">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <div class="footer_width">
              <div class="glzy_top">
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_gyyyj_left">关于仪海仪家</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">联系我们</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">著作权与商标声明</span>
                </a>
                <a class="xuanzhong wenzi" href="">
                  <span class="footer_text2 footer_lxwm_left">隐私政策</span>
                </a>
              </div>
              <div class="glzy_bottom">
                <span class="footer_text2 ">
                  Copyright@2020 海粟智链（青岛）科技有限公司
                  版权所有鲁ICP备 19060515号-1</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-footer>
    </el-container>
  </div>
</template>
<script>

export default {
  name: "category",
  data: function () {
    return {
      is_open: {
        sousuo: 1,
        lanmu: 1,
        phone_shaixuan: 0,
        phone_sousuokuang: 0,
      },
      information: '',
      url:'',
      casezhi:'',
      input:'',
      yemashu:'',
      zongshu:'',
      yemazhi:1,
      searchValue:'',
      id:'',
    }
  },
  methods: {

    init(){
      this.information = this.$store.state.information
      var t = this
      this.information = this.$store.state.information
      t.id = t.$route.params.id
      if (t.searchValue){
        t.input = t.searchValue
      }
      this.list_data()
      this.url = window.config.api_url
      // this.dp_inform()
    },
    input_sj(e){
      var t = this
      t.input = e
      t.list_data()
    },
    list_data(){
      var t = this
      var url = window.config.api_url+'/college/case?shop_id'+t.id
      if (t.input){
        url += '&keywords='+t.input
      }
      if (t.yemazhi){
        url = url+'&page='+t.yemazhi
      }
      t.axios.get(url).then(res=>{
        t.casezhi = res.data.list.data
        t.yemashu = res.data.list.last_page
        t.zongshu = res.data.list.total
      })

    },
    yedianji(e){
      this.yemazhi = e
      this.init()
    },
    fujiaxz(e){
      this.$router.push(this.url+'/storage/'+e);
    },
    handleChange2(e){
      this.$store.commit('savePath',e)

    }
  },

  created() {
    this.init()
  }
}

</script>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
//@head_text : Source Han Sans CN;
@font-face {

}

@import "../../../assets/css/home";
a {
  text-decoration: none !important;
}

.el-footer {
  background-color: #FFFFFF;
  color: #333;
  //text-align: center;
  padding: 0 0;
  //line-height: 60px;
}

.el-main {
  overflow: hidden;
}

.el-header {
  background: #FFFFFF;
  padding: 0 0;

}

.header_pc {
  border-bottom: #4E6EF2 solid 3px;
}


#app {
  background: #F9F9F9;
  .head_dingbu {
    width: 100%;
    height: 38px;
    background: #F4F4F4;

    .head_width {
      width: 90%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;

      .head_dingwei {
        //float: ;
        margin-left: 5px;
        margin-top: 13px;
        position: absolute;
        width: 10px;
        height: 13px;
      }

      .head_youxiang {
        margin-left: 34px;
        margin-top: 13px;
        position: absolute;
        width: 17px;
        height: 13px;
      }

      .head_text_cao_left {
        margin-left: 26px;
      }

      .head_text_xiaoxi_left {
        margin-left: 57px;
      }

      .head_text_denglu_left {
        margin-left: 202px;
      }

      .head_text_shouye_left {
        margin-left: 48px;
      }

      .head_text_shangjia_left {
        margin-left: 44px;
      }

      .head_text_wode_left {
        margin-left: 46px;
      }

      .head_text_kefu_left {
        margin-left: 50px;
      }

      .head_text_wangzhan_left {
        margin-left: 34px;
      }

      .header_logo_top {
        margin-top: 32px;

        .header_logo {
          width: 181px;
          height: 48px;
          float: left;
        }

        .header_sousuo {

          width: 503px;
          height: 45px;
          margin-top: 20px;
          border: 3px solid #4E6EF2;
          border-radius: 5px 0px 0px 5px;
          //margin-left: 20%;
          float: left;

          .header_sousuo_logo {
            width: 14px;
            height: 14px;
            margin-top: 16px;
            margin-left: 13px;
            margin-right: 15px;
            float: left;
          }

          .header_sousuo_tuijian {
            position: absolute;
            margin-top: -22px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            float: left;
            margin-left: 45px;
          }

          .header_sousuo_tuijian_2 {
            margin-left: 125px;
          }

          .header_sousuo_tuijian_3 {
            margin-left: 205px;
          }

          .header_sousuo_tuijian_xuanzhong {
            padding: 5px 10px 1px 10px;
            background: #4E6EF2;
            margin-top: -29px;
            color: #FFFFFF;
            border-radius: 5px 5px 0px 0px;
          }
        }

        .header_sousuo_button {
          margin-top: 20px;
          border: none;
          width: 100px;
          height: 45px;
          background: #4E6EF2;
          border-radius: 0px 5px 5px 0px;

          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #FFFFFF;
        }
      }

      .header_gongye_lianjie {
        margin-top: 36px;

        .header_gongye_kuang {
          float: left;
          width: 220px;
          //height: 45px;
          background: #4E6EF2;
          border-radius: 5px 5px 0px 0px;

          .header_gongye_kuang_text {
            //width: 74px;
            //height: 18px;
            cursor: pointer;
            float: left;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 10px;
            margin-left: 22px;
            //line-height: 100px;
          }

          .header_gongye_kuang_zhuangtai {
            width: 40px;

            background: #FFFFFF;
            border-radius: 2px;
            float: left;
            margin-top: -2px;
            margin-left: 36px;
          }

          .header_gongye_kuang_zhuangtai2 {
            width: 40px;
            height: 3px;
            background: #FFFFFF;
            border-radius: 2px;
            float: left;
            margin-top: -2px;
            margin-left: 130px;
          }
        }

        .header_gongye_lianjie_qiota {
          float: left;
          margin-left: 50px;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          margin-top: 8px;
          //line-height: 100px;
        }

        .header_gongye_lianjie_qiota_xuanzhong {
          font-size: 22px;
          //font-weight: bold;
          color: #4E6EF2;
          margin-top: 4px;
          //line-height: 100px;
        }
      }
    }
  }

  .header_phone {
    background: #f4f4f4;
    color: #333333;
    line-height: 38px;
    font-size: 12px;
    padding-right: 15px;
    padding-left: 15px;
    font-family: Source Han Sans CN;
    font-weight: 600;

    .header_phone_name {
      float: left;
    }

    .head_phone_dingwei {
      float: left;
      width: 10px;
      margin-top: 12px;
      margin-left: 5px;
    }

    .head_phone_huanyi {
      float: left;
      margin-left: 12px;
    }

    .head_phone_xiaoxi_img {
      float: left;
      width: 18px;
      margin-top: 12px;
      margin-left: 20px;
    }

    .head_phone_xiaoxi {
      float: left;
      margin-left: 5px;
    }

    .head_phone_denglu {
      float: right;
      margin-right: 7px;
    }

    .head_phone_zhuce {
      float: right;
    }
  }

  .footer {
    width: 100%;
    height: 255px;
    background: #FFFFFF;
    border-bottom: #E1E1E1 solid 1px;

    .footer_width {
      width: 80%;
      max-width: 1200px;
      margin-right: auto;
      margin-left: auto;

      .xdsk_top {
        position: relative;
        margin-top: 70px;

        .footer_img_xinshou {
          //margin-left: 5px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_duiwai {
          //margin-left: 155px;
          //margin-top: 13px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_shiming {
          //margin-left: 155px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_img_kefu {
          //margin-left: 155px;
          //margin-top: 13px;
          position: absolute;
          width: 50px;
          height: 50px;
        }

        .footer_xinshou_left {
          margin-left: 60px;
        }

        .footer_dsk_left {
          margin-left: 60px;
        }
      }

      .xdsk_bottom {
        margin-top: 38px;

        .footer_kongjian_left {
          margin-left: 17px;
        }

        .footer_jiaoyi_left {
          margin-left: 184px;
        }

        .footer_shiming_left {
        }

        .footer_tousu_left {
          margin-left: 520px;
        }

        .footer_changjian_left {
          margin-left: 945px;
        }
      }

      .glzy_top {
        margin-top: 51px;

        .footer_gyyyj_left {
          padding-right: 20px;
          border-right: #E1E1E1 solid 1px;
        }

        .footer_lxwm_left {
          margin-left: 29px;
          padding-right: 21px;
          border-right: #E1E1E1 solid 1px;
        }
      }

      .glzy_bottom {
        margin-top: 45px;
      }
    }
  }

  .footer_bottom {
    border-bottom: none;
    height: 223px;
  }
}

.youfudong {
  float: right;
}

.head_text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #333333;
  line-height: 38px;
}

.footer_text1 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 150;
  color: #666666;
  //line-height: 30px;
}

.footer_text2 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  //line-height: 30px;
}

.footer_text3 {
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 550;
  color: #333333;
  //line-height: 30px;
}

.main_jinpai_text {
  //width: 78px;
  //height: 25px;
  font-size: 26px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #222222;
  line-height: 30px;
}

.main_jinpai_text2 {
  //width: 327px;
  //height: 50px;
  font-size: 20px;
  font-family: Source Han Sans CN;
  font-weight: 350;
  color: #333333;
  line-height: 30px;
}

.xuanzhong:hover {
  //color:#4E6EF2;
  text-decoration: none;
}

.wenzi {
  text-decoration: none;
}

.lanmu:hover {
  background-color: #FF704D !important;
}

//a:hover {background-color:#FF704D;}
</style>
<style>
.el-input__inner{
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;

}
.el-input--suffix .el-input__inner{
  width: 133px;
  /*line-height: 60px;*/
  height: 27px;
  background: #E1E1E1;
  border-radius: 5px;

}
</style>
<style lang="less" scoped>
@import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";
@head_text : Source Han Sans CN;
@font-face {

}
//@import "../../../assets/css/home";
@import "../../../assets/css/home_case";
</style>
<style lang="less" scoped>
@font-face {

}
</style>
